











































































































import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class PcMallDecorate extends Vue {}
